import React from "react";

/**
 * Branded startup presence — shown while auth/initialization resolves.
 * Replaces the generic three-dot indicator: the Continua mark breathing
 * slowly on the app's dark atmosphere. No spinner, no text, no fake
 * progress, no artificial delay — it unmounts the instant loading ends.
 */
export const BrandedLoading = () => (
  <div
    data-testid="branded-loading-screen"
    className="min-h-screen flex items-center justify-center"
    style={{ background: "#060610" }}
  >
    <div className="flex flex-col items-center gap-4 fade-rise" style={{ animationDuration: "1.1s" }}>
      <img
        src="/continua-logo.png"
        alt=""
        className="w-16 h-16 select-none breathe"
        style={{ animationDuration: "4.8s" }}
        draggable={false}
        data-testid="branded-loading-logo"
      />
      <span
        className="font-serif-display text-xl tracking-[0.18em] text-violet-100/80 breathe"
        style={{ animationDuration: "4.8s", animationDelay: "0.25s" }}
      >
        Continua
      </span>
    </div>
  </div>
);
